let initialState = {
	tabDetails: null,
	tabs: null,
	logScale: false,
	ai: true,
	errorCode: null,
	paneValue: null,

	basevalue: "mentions",
};
const Workspace = (state = initialState, action) => {
	switch (action.type) {
		case "SET_TAB_DETAILS":
			return {
				...state,
				tabDetails: action.payload,
			};
		case "SET_TABS":
			return {
				...state,
				tabs: action.payload,
			};
		case "SET_LOG_SCALE":
			return {
				...state,
				logScale: action.payload,
			};
		case "SET_AI_SCALE":
			return {
				...state,
				ai: action.payload,
			};
		case "SET_ERROR_CODE":
			return {
				...state,
				errorCode: action.payload,
			};
		case "SET_PANE_VALUE":
			return {
				...state,
				paneValue: action.payload,
			};

		case "SET_BASE_VALUE":
			return {
				...state,
				basevalue: action.payload,
			};
		default:
			return state;
	}
};

export default Workspace;
